var contactUs = function () {

    $(function () {

        $("#contactUsServiceCentre").autocomplete({
            source: function (request, response) {

                $("#contactUsServiceCentreEmail").val("");

                $.ajax({
                    url: "/umbraco/surface/contactuspage/getservicecentres",
                    type: "GET",
                    dataType: "json",
                    data: {
                        filter: request.term
                    },
                    success: function (data) {

                        // Populate the array that will be passed to the response callback.
                        var autocompleteObjects = [];
                        for (var i = 0; i < data.length; i++) {
                            var object =
                            {
                                // Used by jQuery Autocomplete to show
                                // autocomplete suggestions as well as
                                // the text in yourInputTextBox upon selection.
                                // Assign them to a value that you want the user to see.
                                value: data[i].Name,
                                label: data[i].Name,

                                // Put our own custom id here.
                                // If you want to, you can even put the result object.
                                id: data[i].Email
                            };

                            autocompleteObjects.push(object);
                        }

                        response(autocompleteObjects);
                    }
                });
            },
            minLength: 2,
            select: function (event, ui) {
                $("#contactUsServiceCentreEmail").val(ui.item.id);
            }
        });

        function adjustFormControls() {
            var selectedValue = $("#EnquiryType").val();

            var freeFreightConsultationValue = "Free Freight Consultation";
            var careerOpportunitiesValue = "Career Opportunities";
            var feedbackValue = "Feedback";
            var franchiseOpportunitiesValue = "Franchise Opportunities";
            var nationalLogisticsSolutionsValue = "National Logistics Solutions";

            if (selectedValue === "Warranty Claim") {
                $("#EnquiryDescWarrantyClaim").show();
                $("#EnquiryDetailsWarrantyClaim").show();
            } else {
                $("#EnquiryDescWarrantyClaim").hide();
                $("#EnquiryDetailsWarrantyClaim").hide();
            }

            if (selectedValue === "Contact Local Service Centre") {
                $("#EnquiryDetailsContactLocalServiceCentre").show();
            } else {
                $("#EnquiryDetailsContactLocalServiceCentre").hide();
            }

            if (selectedValue === freeFreightConsultationValue) {
                $("#EnquiryDetailsFreeFreight").show();

            } else {
                $("#EnquiryDetailsFreeFreight").hide();
            }

            if (selectedValue === nationalLogisticsSolutionsValue ||
                selectedValue === freeFreightConsultationValue) {
                $("#CompanyRow").show();
            } else {
                $("#CompanyRow").hide();
            }

            if (selectedValue === "Feedback") {
                $("#EnquiryDetailsFeedback").show();
            } else {
                $("#EnquiryDetailsFeedback").hide();
            }

            if (selectedValue === freeFreightConsultationValue ||
                selectedValue === careerOpportunitiesValue ||
                selectedValue === feedbackValue) {
                $("#postcode-row").show();
            } else {
                $("#postcode-row").hide();
            }

            if (selectedValue === franchiseOpportunitiesValue) {
                $("#franchise-opportunities-row").show();
                $("#name-row").hide();
                $("#email-phone-row").hide();
                $("#submit-button").hide();
                $("#enquiry-details-row").hide();
            } else {
                $("#franchise-opportunities-row").hide();
                $("#name-row").show();
                $("#email-phone-row").show();
                $("#submit-button").show();
                $("#enquiry-details-row").show();
            }
        }



        $("#EnquiryType").change(function () {
            adjustFormControls();
        });

        adjustFormControls();

        if ($("#ContactUsForm").length > 0) {
           $("#ContactUsForm").validate({
				debug: true,
				submitHandler: function () {

					var formData = new FormData($(this)[0].currentForm);

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/contactuspage/contactuspage",
						data: formData,
						contentType: false,
						processData: false,
						success: function (data) {

							if (data.indexOf("fail") !== -1) {
								$("#FormErrorResponse").removeClass("hidden");
								$("#FormErrorResponse p").text(data);
							} else {
								$("#FormResponse").removeClass("hidden");
								$("#FormResponse p").text(data);
								$("#ContactUsForm").addClass("hidden");
								$(window).scrollTop(0);
							}
						}

					});
					return false;
				}
			});
		}
	});
}

module.exports = contactUs;